<template>
  <div class="epub_box">
    <div class="epub_box_c" style="margin-top: 15px">
      <div class="read_left_box">
        <div class="read_left">
          <div class="title theme-title">商品详情</div>
          <div class="read_leftt1">
            <img class="read_leftt1_img" :src="detail.resourceCover" />
            <div class="title">
              <!-- <div class="book-label">课程</div> -->
              <span>{{ detail.resourceName }}</span>
            </div>
          </div>
          <div class="read_leftt2">
            <li>讲师：{{ detail.lecturer }}</li>
            <li>
              <div
                v-if="
                  (!showTime && showStartTime) || detail.isValidForever == 0
                "
              >
                <span>有效期：</span>
                <span class="ellipsis-aRow" v-if="detail.isValidForever != 0"
                  >截止到{{ formatDate(detail.validEndDate) || "-" }}</span
                >
                <span
                  style="margin-left: 10rpx"
                  v-if="detail.isValidForever == 0"
                  >永久</span
                >
              </div>
              <div
                v-if="showTime && showStartTime && detail.isValidForever != 0"
                style="color: red"
              >
                课程已到期
              </div>
              <div
                v-if="!showStartTime && detail.isValidForever != 0"
                style="color: red"
              >
                课程未开始
              </div>
            </li>
          </div>
        </div>
        <div class="read_left2">
            <div class="radius">
              <div class="text">今日学习时长</div>
            </div>
            <div class = "bottom">
              <img src="../../../../static/img/studyicon.png" alt="">
              <div class="time">
                {{
                  learningTime < 60
                    ? learningTime
                    : (learningTime / 60).toFixed(1)
                }}
                <span style="font-size: 14px">{{
                  learningTime < 60 ? "分钟" : "小时"
                }}</span>
              </div>
            </div>
           
            <!-- <div class="num">
              <span
                style="font-weight: bold; color: #2f7cfb; font-size: 25px"
                >{{ GetQuestion.userQuestion || "0" }}</span
              >/{{ GetQuestion.questionCount || "0" }}
            </div>
            <div class="label">
              <span>已做题目/总题数</span>
            </div> -->
        </div>
      </div>
      <div class="video_box">
        <div class="video_name_row">
          <img class="img_box" src="@/assets/icon/shipin.png" />
          <div>{{ sectionName }}</div>
        </div>
        <div v-if="startVideoUrlshow" style="width: 90%; margin: 20px auto">
          <player
            style="width: 100%; height: 100%"
            ref="video_player"
            @reciveMessage="reciveMessage"
            @videoEnd="videoEnd"
            @videoPause="videoPause"
          ></player>
        </div>
        <div
          v-if="!startVideoUrlshow"
          style="text-align: center; margin-top: 150px; height: 650px"
        >
          <noData></noData>
          <div v-if="isShop" style="color: #999">课程已到期 / 课程未开始</div>
          <div v-if="!isShop" style="color: #999">未购买</div>
        </div>
      </div>
      <div class="list_box">
        <!-- <div class="file-download" @click="dialogVisible = true">资料下载</div> -->
        <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="课程表" name="first"></el-tab-pane>
          <!-- <el-tab-pane label="试题" name="second"></el-tab-pane> -->
        </el-tabs>
        <div class="tabs_box" v-if="activeName == 'first'">
          <el-collapse
            v-model="course"
            @change="handleChange"
            v-if="!courseListshow"
          >
            <el-collapse-item
              v-for="(item, index) in courseList"
              :title="item.name"
              :key="index"
              :name="index + 1"
            >
              <div v-for="(items, indexs) in item.sections" :key="indexs">
                <div
                  class="row"
                  @click="startVideo(items, item.name, index)"
                  style="margin-top: 5px"
                >
                  <div
                    class="collapse"
                    :class="items.content == vid ? 'color' : ''"
                  >
                    {{ items.name }}
                  </div>
                  <div class="row">
                    <img src="@/assets/images/time.png" />
                    <span class="collapse">{{ xgetTime(items.duration) }}</span>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <noData v-if="courseListshow"></noData>
        </div>
        <div class="tabs_box" v-if="activeName == 'second'">
          <div v-if="!papershow">
            <div v-for="(item, index) in paperList" :key="index">
              <div class="shiti_row">
                <div class="text">
                  <div>{{ item.paperName }}</div>
                  <div>
                    <span style="color: #2e9adb">{{ item.useNum }}</span
                    >/{{ item.questionNum }}
                  </div>
                </div>
                <div class="but" @click="anwser(item.id)">去答题</div>
              </div>
            </div>
          </div>
          <noData v-if="papershow"></noData>
        </div>
      </div>
    </div>

    <!-- 资源下载弹窗 -->
    <el-dialog title="资料下载" :visible.sync="dialogVisible" width="750px">
      <div
        class="download-item"
        v-for="(item, index) in otherList"
        :key="index"
      >
        <div class="title">{{ item.sourceName }}</div>
        <div class="button" @click="download(item)">下载</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { checkIsBuy } from "@/api/bookstore/bookstore";
import noData from "@/components/noData.vue";
import player from "@/views/willingLearn/bookstore/player.vue";
import { videourl } from "@/utils/config.js";
import { OuchnOss } from "@/plugins/OuchnOss";
import {
  selectOcLexueResourceBookCourseById,
  selectOclexueResourceBookById,
  getLexueReadTime,
  selectTimeParameter,
  GetQuestionIsUse,
  updateLexuePlayedbackSchedule,
  saveProgress,
  getUserLastRead,
} from "@/api/willingLearn/index.js";
export default {
  components: { noData, player },
  computed: {},
  data() {
    return {
      videourl: videourl,
      activeName: "first",
      payType: "goods",
      courseList: [],
      courseListshow: false,
      paperList: [],
      course: [1],
      goodsId: this.$route.query.goodsId,
      detail: "",
      learningTime: 0,
      timer: null,
      GetQuestion: "",
      frequency: 1,
      currentTime: 0,
      duration: 0,
      startTime: 0,
      chapterName: "",
      videoData: {},
      vid: "",
      showTime: false,
      showStartTime: true,
      isShop: true, //判断购买
      sectionName: "",
      startVideoUrlshow: true,
      playState: false,
      papershow: false,
      courseCover: "",
      dialogVisible: false,
      otherList: [],
      total: 0,
      OuchnOss: null,
    };
  },
  watch: {
    //监听路由变化
    $route() {},
  },
  created() {
    this.OuchnOss = new OuchnOss();
    this.course[0] = localStorage.getItem("vidIndex")
      ? Number(localStorage.getItem("vidIndex"))
      : 1;
    this.loading = this.$loading({
      lock: true,
    });
    setTimeout(() => {
      this.loading.close();
      this.selectOclexueResourceBookByIds();
      // 获取乐学商品当天学习时长
      getLexueReadTime({ goodsId: this.goodsId }).then((res) => {
        this.learningTime = res.data || 0;
      });
    }, 500);
  },
  beforedestroy() {
    this.updatePlayedbackSchedule();
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    console.log(this.course);
    selectTimeParameter().then((res) => {
      this.frequency = res.data || 1;
    });
  },
  methods: {
    checkIsBuys() {
      //判断是否已经购买该商品
      this.payType = "goods";
      checkIsBuy({ relevanceId: this.goodsId, type: this.payType }).then(
        (res) => {
          if (res.data === "2") {
            this.$message.error("数据异常");
            return;
          }

          if (res.data === "1") {
            this.isShop = false;
            this.isPayGoods();
          } else {
            this.isShop = true;
            //课程数量
            this.selectOcLexueResourceBookCourseByIds();
            //试卷数量
            GetQuestionIsUse({ goodsId: this.goodsId }).then((res) => {
              if (res.data) {
                this.GetQuestion = res.data;
                this.paperList = res.data.paperInfo || [];
                this.papershow = false;
              } else {
                this.papershow = true;
              }
            });
          }
        }
      );
    },
    isPayGoods() {
      //走购买流程
      this.startVideoUrlshow = false;
      this.courseListshow = true;
      this.papershow = true;
      let title = "该文件需要购买后才能阅读，是否确认购买";
      this.$alert(`${title}`, "购买", {
        confirmButtonText: "立即购买",
        callback: (action) => {
          if (action === "cancel") {
            return;
          }
          let userId = this.$store.getters.userId;
          if (!userId) {
            this.$router.push({
              path: "/login",
              query: {
                redirectPath: "/onlineReading",
              },
            });
          } else {
            //判断是否购买该商品
            this.payType = "goods";
            checkIsBuy({
              relevanceId: this.goodsId,
              type: this.payType,
            }).then((res) => {
              console.log("是否已购买响应", res);
              if (res.data === "2") {
                this.$message.error("数据异常");
                return;
              }
              if (res.data === "1") {
                this.$router.push({
                  path: "/submitOrder/index",
                  query: {
                    id: this.$route.query.goodsId,
                    from: "bookstore",
                  },
                });
              } else {
                this.$message("该商品已购买无需重复购买");
              }
            });
          }
        },
      });
    },
    //播放时返回
    reciveMessage(e) {
      if (e) {
        console.log(e);
        if (e.name == "videoPlay") {
          if (!this.playState) {
            this.playState = true;
            this.updatePlayedbackSchedule();
          }
          this.currentTime = e.video.currentTime;
          this.duration = e.video.duration;
          this.startTime++;
          if (this.startTime == this.frequency * 60) {
            this.startTime = 0;
            saveProgress({
              goodsId: this.goodsId,
            }).then(() => {
              getLexueReadTime({ goodsId: this.goodsId }).then((res) => {
                this.learningTime = res.data || 0;
              });
              this.updatePlayedbackSchedule();
            });
          }
        }
      }
    },
    videoEnd(e) {
      if (e) {
        if (e.name == "videoEnd") {
          this.currentTime = e.video.currentTime;
          this.duration = e.video.duration;
          saveProgress({
            goodsId: this.goodsId,
          }).then(() => {
            getLexueReadTime({ goodsId: this.goodsId }).then((res) => {
              this.learningTime = res.data || 0;
            });
            this.updatePlayedbackSchedule();
          });
        }
      }
    },
    videoPause(e) {
      if (e) {
        if (e.name == "videoPause") {
          this.currentTime = e.video.currentTime;
          this.duration = e.video.duration;
          saveProgress({
            goodsId: this.goodsId,
          }).then(() => {
            getLexueReadTime({ goodsId: this.goodsId }).then((res) => {
              this.learningTime = res.data || 0;
            });
            this.updatePlayedbackSchedule();
          });
        }
      }
    },
    // 更新用户乐学模块播放记录
    updatePlayedbackSchedule() {
      updateLexuePlayedbackSchedule({
        chapterId: this.vid,
        chapterName: this.chapterName,
        sectionName: this.sectionName,
        goodsId: this.goodsId,
        playbackDuration: this.currentTime,
        playbackLocation:
          this.currentTime > 0 && this.duration > 0
            ? ((this.currentTime * 100) / (this.duration * 100)).toFixed(2)
            : 0,
      });
    },
    //商品列表
    selectOclexueResourceBookByIds() {
      let data = {
        id: this.goodsId,
      };
      selectOclexueResourceBookById(data).then((res) => {
        this.detail = res.data;
        let strEnd = this.detail.validEndDate;
        if (this.detail.isValidForever != 0) {
          if (new Date(strEnd).getTime() > Date.now()) {
            this.showTime = false;
          } else {
            this.showTime = true;
          }
          let Start = this.detail.validStartDate;
          if (new Date(Start).getTime() > Date.now()) {
            this.showStartTime = false;
          } else {
            this.showStartTime = true;
          }
        }
        // this.checkIsBuys();
        this.selectOcLexueResourceBookCourseByIds();
      });
    },
    //课程
    selectOcLexueResourceBookCourseByIds() {
      selectOcLexueResourceBookCourseById(this.goodsId).then((res) => {
        this.otherList = res.data.other || [];
        this.total = this.otherList.length;
        this.courseList = JSON.parse(res.data.course.chapters) || [];
        this.courseCover = res.data.course.cover || "";
        if (this.courseList.length > 0) {
          this.getUserLastReads();
          this.courseListshow = false;
        } else {
          this.courseListshow = true;
        }
      });
    },
    //首次加载
    getUserLastReads() {
      getUserLastRead(this.goodsId).then((res) => {
        let time = 0;
        //有播放记录
        if (res.data.length > 0) {
          let lastRead = res.data[0];
          lastRead.sectionName ? (this.sectionName = lastRead.sectionName) : "";
          lastRead.chapterName ? (this.chapterName = lastRead.chapterName) : "";
          lastRead.chapterId ? (this.vid = lastRead.chapterId) : "";
          time = lastRead.playbackDuration;
        }
        //没有历史播放
        if (res.data.length == 0) {
          //判断课程是否到开始时间
          if (this.showStartTime && !this.showTime) {
            this.sectionName = this.courseList[0].sections[0].name;
            this.chapterName = this.courseList[0].name;
            this.vid = this.courseList[0].sections[0].content;
            this.videoData = this.courseList[0].sections[0];
            time = 0;
          } else {
            this.startVideoUrlshow = false;
            return;
          }
        }
        setTimeout(() => {
          this.$refs.video_player.DmsPlayers(
            3,
            18,
            this.vid,
            this.courseCover,
            time
          );
        }, 200);
      });
    },
    //点击切换
    startVideo(item, chapterName, index) {
      if (!this.showStartTime) {
        this.$message({
          message: "课程未开始",
        });
        return;
      }
      if (this.showTime) {
        this.$message({
          message: "课程已过期",
        });
        return;
      }
      this.playState = false;
      this.vid = item.content;
      this.chapterName = chapterName;
      this.sectionName = item.name;
      this.$refs.video_player.destroy()
      setTimeout(() => {
        this.$refs.video_player.DmsPlayers(
          3,
          18,
          this.vid,
          this.courseCover,
          0
        );
      }, 200);
    },
    handleClick() {},
    handleChange() {},
    anwser(id) {
      if (!this.showStartTime) {
        this.$message({
          message: "课程未开始",
        });
        return;
      }
      if (this.showTime) {
        this.$message({
          message: "课程已到期",
        });
        return;
      }
      let url = this.$router.resolve({
        path: "/willingLearn/paper/testPaper",
        query: {
          id: id,
          goodsId: this.goodsId,
          teachProperty: this.detail.teachProperty,
        },
      });
      window.open(url.href, "_blank");
    },
    xgetTime(time) {
      let h = parseInt(time / 60 / 60);
      let m = parseInt(time / 60);
      let s = time % 60;
      let date =
        (h > 9 ? h : "0" + h) +
        ":" +
        (m > 9 ? m : "0" + m) +
        ":" +
        (s > 9 ? s : "0" + s);
      return date;
    },
    formatDate(time) {
      var date = new Date(time);
      var year = date.getFullYear(),
        month = date.getMonth() + 1, //月份是从0开始的
        day = date.getDate(),
        hour = date.getHours(),
        min = date.getMinutes(),
        sec = date.getSeconds();
      var newTime =
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (day < 10 ? "0" + day : day);
      //  + ' ' +
      // (hour < 10 ? '0' + hour : hour) + ':' +
      // (min < 10 ? '0' + min : min) + ':' +
      // (sec < 10 ? '0' + sec : sec);
      return newTime;
    },

    download(item) {
      this.downloadByUrl(item.fullUrl, item.sourceName);
    },
    downloadByUrl(url, fileName) {
      const elink = document.createElement("a");

      elink.href = url;
      elink.download = fileName;

      elink.style.display = "none";

      document.body.appendChild(elink);

      setTimeout(() => {
        elink.click();

        document.body.removeChild(elink);
      }, 66);
    },
  },
};
</script>
<style scoped lang="scss">
.epub_box {
  max-width: 100%;
  overflow: hidden;
  background: rgb(242, 242, 242);
  padding: 0 20px;
  box-sizing: border-box;
  margin: 0 auto;
}

.epub_box_c {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.read_left_box {
  width: 300px;
}

.read_left {
  width: 100%;
  float: left;
  margin-bottom: 16px;
  padding: 15px;
  box-sizing: border-box;
  background: #fff;
}

.epub_box .bread {
  width: 100% !important;
}

.read_leftt1 {
  margin-top: 12px;
  margin-bottom: 12px;
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    margin-left: 15px;
    .book-label {
      padding: 0 5px;
      height: 24px;
      background: #f9fdff;
      margin-right: 7px;
      border: 1px solid #0081ce;
      border-radius: 6px;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #0081ce;
      line-height: 24px;
      text-align: center;
    }
    span {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: black;
      font-weight: bold;
    }
  }
}

.read_leftt1_img {
  width: 150px;
  height: 150px;
  display: block;
  margin: 0 auto;
  box-shadow: 3px #ccc;
  margin-bottom: 14px;
}

.read_leftt2 {
  width: 100%;
  overflow: hidden;
  padding: 0 12px;
  box-sizing: border-box;
  padding-bottom: 10px;
}

.read_leftt2 li {
  list-style: none;
  width: 100%;
  float: left;
  font-size: 14px;
  margin-bottom: 8px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}

.read_left2 {
  width: 100%;
  height: 140px;
  float: left;
  margin-bottom: 16px;
  padding: 15px;
  box-sizing: border-box;
  background: url("../../../../static/img/backageImage.jpg") no-repeat;
  position: relative;
}

.radius {
  position: absolute;
  top: 0;
  left: 56px;
  background-color: #1690ff;
  border-radius: 0px 0px 30px 30px;
  width: 168px;
  height: 30px;
 
    .text {
      padding-top: 3px;
      text-align: center;
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      // font-weight: 600;
      color: #ffffff;
    }
  }

  .bottom{
    display: flex;
    text-align: center;
    justify-self: center;
    img{
      margin-top: 32px;
    }
    .time{
      margin-top: 46px;
			text-align: center;
			color: #1690FF;
			font-size: 26px;
			font-weight: 600;
    }

  }
  .num {
    text-align: center;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }

  .label {
    text-align: center;
    margin: 14px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
.video_box {
  width: calc(100% - 680px);
  height: auto;
  min-height: 740px;
  margin-bottom: 20px;
  background: #fffefd;
  .video_name_row {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 0;
    margin: 0 10px;
    border-bottom: 1px solid #f2f2f2;
    .img_box {
      margin-right: 8px;
    }
  }
}
.list_box {
  float: right;
  width: 360px;
  height: 600px;
  background: #fffefd;
  .file-download {
    margin: 10px auto;
    width: 150px;
    height: 30px;
    background: #1690ff;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }
 /* .tabs {
    width: 160px;
    margin: 0 auto;
  }
  */

  .tabs {
    width: 42px;
    margin: 0 auto;
  }

  .tabs_box {
    padding: 0 15px;
    height: 550px;
    overflow: hidden;
    overflow-y: auto;
  }
}
.collapse {
  padding: 5px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
}
.color {
  color: #1690ff;
}
.collapse_size {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 26px;
}
.el-collapse-item__header ::v-deep {
  background: #fffefd !important;
}
::v-deep .el-collapse-item__content {
  background: #fffefd !important;
  padding-bottom: 0px;
}
::v-deep .el-collapse-item__wrap {
  border-bottom: 0px;
}
::v-deep .el-collapse-item__header {
  border-bottom: 0px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}
::v-deep .el-tabs .el-tabs__nav-wrap::after {
  height: 0px !important;
}
//样式穿透
::v-deep .el-collapse-item__header {
  // height: 40px;
  line-height: 30px;
  height: auto;
  // padding: 10px 0;
}
::v-deep .el-collapse {
  border: 0;
}
.shiti_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #f2f2f2;
  padding: 5px;
  margin-top: 5px;
  .text {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .but {
    width: 50px;
    text-align: center;
    background: #70b603;
    border-radius: 12px;
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 400;
    padding: 2px 5px;
    color: #ffffff;
    cursor: pointer;
  }
}
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #f2f2f2;
  cursor: pointer;
  img {
    height: 12px;
    width: 12px;
  }
}
.papershow {
  margin-top: 100px;
  text-align: center;
}
.download-item {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 658px;
  height: 54px;
  padding: 0 14px;
  background: #f2f2f2;
  .title {
    width: 580px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .button {
    width: 60px;
    height: 24px;
    background: #70b603;
    border-radius: 12px;
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
